import { Alert, Button, Group, Text } from '@mantine/core'
import { Icon } from '@iconify/react'
import { useActions, useAppState } from 'src/state'

export const NotificationPrompt = () => {

    const { permission, initialized, promptDismissed } = useAppState(state => state.notifications)
    const { requestNotificationPermission, dismissNotificationPrompt } = useActions()

    if (!initialized || permission !== 'default' || promptDismissed) return null

    return (
        <Alert
            icon={<Icon icon="mdi:bell-ring-outline" width={18} />}
            color="blue"
            radius="md"
            mb="md"
        >
            <Group justify="space-between" align="center">
                <Text size="sm">
                    Enable push notifications to stay updated on your bookings.
                </Text>
                <Group gap="xs">
                    <Button
                        size="xs"
                        variant="filled"
                        onClick={() => requestNotificationPermission()}
                    >
                        Enable
                    </Button>
                    <Button
                        size="xs"
                        variant="subtle"
                        color="gray"
                        onClick={() => dismissNotificationPrompt()}
                    >
                        Not now
                    </Button>
                </Group>
            </Group>
        </Alert>
    )

}
